export const eulaKeyContent = 'epic_content';
export const eulaKeyUnreal = 'unreal_engine2';
